module.exports = __webpack_public_path__ + "img/conception-engineering-2.e20216e0.jpeg";